//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiLinkedin, mdiPlus } from "@mdi/js";
import blokProp from "~/helpers/blok-prop";
const __sfc_main = {};
__sfc_main.props = { ...blokProp,
  isOpen: Boolean,
  toggle: {
    type: Function,
    default: () => {}
  }
};

__sfc_main.setup = (__props, __ctx) => {
  return {
    mdiLinkedin,
    mdiPlus
  };
};

export default __sfc_main;
